import React from 'react';

// --- Main List Data from Screenshot ---
const mainListItems = [
  "Introduction to website development",
  "How websites work",
  "Fundamentals of html",
  "Beautifying websites with css",
  "Basics of javascript",
  "Intermediate Javascript",
  "Introduction to dynamic website development",
  "Basics of php",
  "Intermediate php",
  "Introduction to Database Management System",
  "Basics of SQL",
  "Intermediate SQL",
  "Building your own banking website",
  "Connecting your website to live server",
  "Uploading your website to live server",
  "Configuring basic security settings of your website",
];

// --- Tools List Data from Screenshot ---
const toolsListLeft = [
  "html",
  "css",
  "javascript",
  "php",
];

const toolsListRight = [
  "Database Management System (DBMS)",
  "SQL",
  "VS Code",
  "Server Management",
];

// --- Internal CSS for all styling ---
// Class names have been prefixed with 'c2pg-' for uniqueness.
const internalCSS = `
  /* --- Main Page Container --- */
  .c2pg-chapter-page-container {
    background-color: #fff; /* White background for the whole page */
    font-family: 'Poppins', 'Open Sans', sans-serif; /* Consistent font */
  }

  /* --- 1. Top Banner Section --- */
  .c2pg-chapter-top-banner {
    position: relative;
    width: 100%;
    height: 350px; 
    overflow: hidden;
    display: flex;
    flex-direction: column; 
    justify-content: center; 
    background-color: #1a1a1a; 
    padding: 1rem 2rem; 
  }

  .c2pg-chapter-banner-bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    opacity: 0.5; /* Dim the image */
  }

  .c2pg-chapter-banner-content {
    position: relative;
    z-index: 1;
    color: #fff;
    text-align: left;
    max-width: 960px; /* Max width for content */
    margin: 0 auto; /* Center content horizontally */
    width: 100%; 
  }

  .c2pg-chapter-badge {
    background-color: #dc3545; /* Red color */
    color: #fff;
    font-size: 0.9rem;
    font-weight: 600;
    padding: 0.2rem 0.75rem;
    border-radius: 4px;
    display: inline-block; 
    margin-bottom: 0.75rem;
  }

  .c2pg-chapter-main-title {
    font-size: 2.8rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0;
  }

  /* --- 2. List Section --- */
  .c2pg-chapter-list-section {
    padding: 4rem 1rem;
    background-color: #fff;
  }

  .c2pg-chapter-list-container {
    max-width: 960px; /* Align with banner content */
    margin: 0 auto;
    width: 100%;
  }

  .c2pg-chapter-list {
    list-style-type: disc; /* Default bullet style */
    padding-left: 1.5rem; /* Standard indent for list */
  }

  .c2pg-chapter-list li {
    font-size: 1.15rem;
    line-height: 1.8;
    color: #333;
    margin-bottom: 0.5rem; /* Space between list items */
    font-weight: 500; /* Medium weight, as seen in image */
  }

  /* --- Tools and Technologies Section --- */
  .c2pg-tools-title {
    font-size: 1.75rem;
    font-weight: 700; /* Bold */
    color: #212529; /* Dark color */
    margin-top: 3rem;  /* Space above */
    margin-bottom: 1.5rem;
  }
  
  /* Bolder and slightly smaller than main list */
  .c2pg-tools-list li {
    font-size: 1.1rem;
    font-weight: 700; /* Bold */
    line-height: 1.7;
  }
  
  /* --- Responsive Adjustments --- */
  @media (max-width: 991.98px) { /* Tablets */
    .c2pg-chapter-top-banner {
      height: 300px;
    }
    .c2pg-chapter-main-title { 
      font-size: 2.4rem;
    }
    .c2pg-chapter-list li {
      font-size: 1.05rem;
      line-height: 1.7;
    }
  }

  @media (max-width: 767.98px) { /* Mobile Devices */
    .c2pg-chapter-top-banner {
      height: 130px;
      justify-content: flex-end; 
      padding-bottom: 1.5rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .c2pg-chapter-banner-content {
         text-align: start !important;
         
    }
    .c2pg-chapter-badge {
      font-size: 0.8rem !important;
      padding: 0.15rem 0.5rem;
      margin-bottom: 0.5rem;
    }
    .c2pg-chapter-main-title {
      font-size: 1.2rem !important;
      line-height: 1.1;
    }
    .c2pg-chapter-list-section {
      padding: 2rem 1rem;
    }
    .c2pg-chapter-list {
      padding-left: 1.25rem; /* Reduce indent on mobile */
    }
    .c2pg-chapter-list li {
      font-size: 0.95rem; /* Smaller text on mobile */
      line-height: 1.6;
      margin-bottom: 0.4rem;
    }
    
    /* Responsive for Tools */
    .c2pg-tools-title {
      font-size: 1.4rem;
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
    
    /* --- CHANGED: Shrink tools list to fit side-by-side --- */
    .c2pg-tools-list {
      padding-left: 1rem; /* Less indent */
    }
    .c2pg-tools-list li {
      font-size: 0.8rem; /* Even smaller font to fit */
      font-weight: 600;
      line-height: 1.5;
    }
  }
`;

const Chapter2Page = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="c2pg-chapter-page-container">
        
        {/* --- 1. Top Banner Section --- */}
        <div className="c2pg-chapter-top-banner">
          <img 
            src="https://skillsuprise.com/data/cyberPDF/chapters/chapter2.png" 
            alt="Chapter 2 Background" 
            className="c2pg-chapter-banner-bg-img" 
          />
          <div className="c2pg-chapter-banner-content">
            <span className="c2pg-chapter-badge">Chapter 2</span>
            <h1 className="c2pg-chapter-main-title">
              Introduction to Programming and Website Development
            </h1>
          </div>
        </div>
        
        {/* --- 2. List Section --- */}
        <div className="c2pg-chapter-list-section">
          <div className="c2pg-chapter-list-container">
            
            {/* --- Main Bullet List --- */}
            <ul className="c2pg-chapter-list">
              {mainListItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            {/* --- Tools & Technologies Section --- */}
            <h2 className="c2pg-tools-title">Tools and Technologies</h2>
            
            {/* --- CHANGED: This row now uses col-6 for all sizes --- */}
            <div className="row">
              {/* Left Column */}
              <div className="col-6">
                <ul className="c2pg-chapter-list c2pg-tools-list">
                  {toolsListLeft.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              
              {/* Right Column */}
              <div className="col-6">
                <ul className="c2pg-chapter-list c2pg-tools-list">
                  {toolsListRight.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Chapter2Page;

